import React from 'react';

/**
 * Card atoms — thin wrappers over the globally themed .card classes so pages
 * stop hand-rolling card markup. All surfaces come from tokens.
 *
 *   <Card>
 *     <CardHeader title="Classes" actions={<Button variant="primary" size="sm">Add</Button>} />
 *     <CardBody>...</CardBody>
 *   </Card>
 */
export const Card = ({ children, className = '' }) => (
  <div className={`card ${className}`.trim()}>{children}</div>
);

export const CardHeader = ({ title, actions = null, children, className = '' }) => (
  <div className={`card-header d-flex justify-content-between align-items-center ${className}`.trim()}>
    {title ? <h5 className="mb-0">{title}</h5> : children}
    {actions}
  </div>
);

export const CardBody = ({ children, className = '' }) => (
  <div className={`card-body ${className}`.trim()}>{children}</div>
);

export default Card;
